/**
 * Session-scoped buy-source preview cache (keyed by preview_token).
 * Repeated hovers reuse cached blob URLs without re-POST/GET.
 */

const cache = new Map();

export function getCachedPreview(previewToken) {
  if (!previewToken) return null;
  return cache.get(previewToken) || null;
}

export function setCachedPreview(previewToken, entry) {
  if (!previewToken || !entry) return;
  const prev = cache.get(previewToken);
  if (prev?.imageUrl && prev.imageUrl !== entry?.imageUrl) {
    try {
      URL.revokeObjectURL(prev.imageUrl);
    } catch {
      /* ignore */
    }
  }
  cache.set(previewToken, entry);
}

export function clearPreviewCache() {
  for (const entry of cache.values()) {
    if (entry?.imageUrl) {
      try {
        URL.revokeObjectURL(entry.imageUrl);
      } catch {
        /* ignore */
      }
    }
  }
  cache.clear();
}

export function previewCacheSize() {
  return cache.size;
}
